// Shared accordion toggle (snippets/makc-accordion-item.liquid).
//
// One delegated click listener on the document rather than one per
// header: items rendered later still work, and the run-once guard means
// a second copy of this script on the page (a section rendered twice)
// can't bind a second listener that would undo every tap.
//
// aria-expanded on the header is the only state. The panel's inert
// attribute follows it so a collapsed panel's links and buttons leave the
// tab order. Where a browser doesn't support inert the attribute does
// nothing and the panel simply stays reachable, as before.
window.makcAccordion = window.makcAccordion || (function () {
  function headerOf(item) {
    return item.querySelector(':scope > .makc-accordion__header');
  }

  function setExpanded(item, expanded) {
    var header = item ? headerOf(item) : null;
    if (!header) return;
    var panel = document.getElementById(header.getAttribute('aria-controls'));
    header.setAttribute('aria-expanded', String(expanded));
    if (panel) {
      if (expanded) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    }
  }

  document.addEventListener('click', function (event) {
    var header = event.target.closest('.makc-accordion__header');
    if (!header) return;
    var item = header.parentElement;
    if (!item || !item.hasAttribute('data-makc-accordion')) return;
    setExpanded(item, header.getAttribute('aria-expanded') !== 'true');
  });

  return {
    setExpanded: setExpanded
  };
})();
